import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';

interface DocumentOrderControlProps {
  name: string;
  index: number;
  count: number;
  onMove: (index: number) => void;
  onDragStart: (event: React.DragEvent) => void;
  onDragEnd: () => void;
}

/** Drag on desktop; the position picker also supports touch and keyboard input. */
export default function DocumentOrderControl({
  name,
  index,
  count,
  onMove,
  onDragStart,
  onDragEnd,
}: DocumentOrderControlProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title="드래그하여 문서 순서 변경">
        <IconButton
          size="small"
          draggable={count > 1}
          aria-label={`${name} 순서 이동`}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          sx={{ cursor: count > 1 ? 'grab' : 'default' }}
        >
          <DragIndicator fontSize="small" />
        </IconButton>
      </Tooltip>
      <Box
        component="select"
        aria-label={`${name} 순서`}
        value={index}
        disabled={count < 2}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
          onMove(Number(event.target.value))
        }
        sx={{
          color: 'text.primary',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          minHeight: 36,
          maxWidth: 80,
        }}
      >
        {Array.from({ length: count }, (_, position) => (
          <option key={position} value={position}>
            {position + 1}번째
          </option>
        ))}
      </Box>
    </Box>
  );
}
